// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"539":"96cf4f18","930":"4c3adedf"}[chunkId] + ".chunk.css";
};